import { connect } from 'react-redux';

import { getIsMobile, getIsWhitelabel } from 'src/store/view/selectors';
import { getDataFromTravelRequirements } from 'src/routes/SearchPage/store/travelRequirements/selectors';
import { entryRulesClickedAction } from 'src/routes/SearchPage/store/travelRequirements/actions';
import { EntryRules } from './EntryRules';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  travelRequirements: getDataFromTravelRequirements(state),
  isWhiteLabel: getIsWhitelabel(state),
});

const mapDispatchToProps = {
  onEntryRulesClick: entryRulesClickedAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryRules);
